const CREATE_CONSTRUCTOR_PROGRAM_REQUEST = "CREATE_CONSTRUCTOR_PROGRAM_REQUEST";
const CREATE_CONSTRUCTOR_PROGRAM_COMPLETED = "CREATE_CONSTRUCTOR_PROGRAM_COMPLETED";
const CREATE_CONSTRUCTOR_PROGRAM_ERROR = "CREATE_CONSTRUCTOR_PROGRAM_ERROR";

const UPDATE_CONSTRUCTOR_PROGRAM_REQUEST = "UPDATE_CONSTRUCTOR_PROGRAM_REQUEST";
const UPDATE_CONSTRUCTOR_PROGRAM_COMPLETED = "UPDATE_CONSTRUCTOR_PROGRAM_COMPLETED";
const UPDATE_CONSTRUCTOR_PROGRAM_ERROR = "UPDATE_CONSTRUCTOR_PROGRAM_ERROR";

const GET_ALL_BLOCK_PROGRAM_REQUEST = "GET_ALL_BLOCK_PROGRAM_REQUEST";
const GET_ALL_BLOCK_PROGRAM_COMPLETED = "GET_ALL_BLOCK_PROGRAM_COMPLETED";
const GET_ALL_BLOCK_PROGRAM_ERROR = "GET_ALL_BLOCK_PROGRAM_ERROR";

const GET_ALL_MODULE_PROGRAM_REQUEST = "GET_ALL_MODULE_PROGRAM_REQUEST";
const GET_ALL_MODULE_PROGRAM_COMPLETED = "GET_ALL_MODULE_PROGRAM_COMPLETED";
const GET_ALL_MODULE_PROGRAM_ERROR = "GET_ALL_MODULE_PROGRAM_ERROR";

const CREATE_BLOCK_PROGRAM_REQUEST = "CREATE_BLOCK_PROGRAM_REQUEST";
const CREATE_BLOCK_PROGRAM_COMPLETED = "CREATE_BLOCK_PROGRAM_COMPLETED";
const CREATE_BLOCK_PROGRAM_ERROR = "CREATE_BLOCK_PROGRAM_ERROR";

const UPDATE_BLOCK_PROGRAM_REQUEST = "UPDATE_BLOCK_PROGRAM_REQUEST";
const UPDATE_BLOCK_PROGRAM_COMPLETED = "UPDATE_BLOCK_PROGRAM_COMPLETED";
const UPDATE_BLOCK_PROGRAM_ERROR = "UPDATE_BLOCK_PROGRAM_ERROR";

const DELETE_BLOCK_PROGRAM_REQUEST = "DELETE_BLOCK_PROGRAM_REQUEST";
const DELETE_BLOCK_PROGRAM_COMPLETED = "DELETE_BLOCK_PROGRAM_COMPLETED";
const DELETE_BLOCK_PROGRAM_ERROR = "DELETE_BLOCK_PROGRAM_ERROR";

const ADD_MODULE_PROGRAM_REQUEST = "ADD_MODULE_PROGRAM_REQUEST";
const ADD_MODULE_PROGRAM_COMPLETED = "ADD_MODULE_PROGRAM_COMPLETED";
const ADD_MODULE_PROGRAM_ERROR = "ADD_MODULE_PROGRAM_ERROR";

const REMOVE_MODULE_PROGRAM_REQUEST = "REMOVE_MODULE_PROGRAM_REQUEST";
const REMOVE_MODULE_PROGRAM_COMPLETED = "REMOVE_MODULE_PROGRAM_COMPLETED";
const REMOVE_MODULE_PROGRAM_ERROR = "REMOVE_MODULE_PROGRAM_ERROR";

const SEND_PROGRAM_APPROVE_REQUEST = "SEND_PROGRAM_APPROVE_REQUEST";
const SEND_PROGRAM_APPROVE_COMPLETED = "SEND_PROGRAM_APPROVE_COMPLETED";
const SEND_PROGRAM_APPROVE_ERROR = "SEND_PROGRAM_APPROVE_ERROR";

const GET_PROGRAM_AUTHORS_REQUEST = "GET_PROGRAM_AUTHORS_REQUEST";
const GET_PROGRAM_AUTHORS_COMPLETED = "GET_PROGRAM_AUTHORS_COMPLETED";
const GET_PROGRAM_AUTHORS_ERROR = "GET_PROGRAM_AUTHORS_ERROR";

const SEND_PROGRAM_AUTHORS_REQUEST = "SEND_PROGRAM_AUTHORS_REQUEST";
const SEND_PROGRAM_AUTHORS_COMPLETED = "SEND_PROGRAM_AUTHORS_COMPLETED";
const SEND_PROGRAM_AUTHORS_ERROR = "SEND_PROGRAM_AUTHORS_ERROR";

const CHANGE_PROGRAM_INFORMATION = "CHANGE_PROGRAM_INFORMATION";

export default {
  GET_ALL_BLOCK_PROGRAM_REQUEST,
  GET_ALL_BLOCK_PROGRAM_COMPLETED,
  GET_ALL_BLOCK_PROGRAM_ERROR,

  GET_ALL_MODULE_PROGRAM_REQUEST,
  GET_ALL_MODULE_PROGRAM_COMPLETED,
  GET_ALL_MODULE_PROGRAM_ERROR,

  CREATE_CONSTRUCTOR_PROGRAM_REQUEST,
  CREATE_CONSTRUCTOR_PROGRAM_COMPLETED,
  CREATE_CONSTRUCTOR_PROGRAM_ERROR,

  UPDATE_CONSTRUCTOR_PROGRAM_REQUEST,
  UPDATE_CONSTRUCTOR_PROGRAM_COMPLETED,
  UPDATE_CONSTRUCTOR_PROGRAM_ERROR,

  CHANGE_PROGRAM_INFORMATION,

  CREATE_BLOCK_PROGRAM_REQUEST,
  CREATE_BLOCK_PROGRAM_COMPLETED,
  CREATE_BLOCK_PROGRAM_ERROR,
  UPDATE_BLOCK_PROGRAM_REQUEST,
  UPDATE_BLOCK_PROGRAM_COMPLETED,
  UPDATE_BLOCK_PROGRAM_ERROR,
  DELETE_BLOCK_PROGRAM_REQUEST,
  DELETE_BLOCK_PROGRAM_COMPLETED,
  DELETE_BLOCK_PROGRAM_ERROR,
  ADD_MODULE_PROGRAM_REQUEST,
  ADD_MODULE_PROGRAM_COMPLETED,
  ADD_MODULE_PROGRAM_ERROR,
  REMOVE_MODULE_PROGRAM_REQUEST,
  REMOVE_MODULE_PROGRAM_COMPLETED,
  REMOVE_MODULE_PROGRAM_ERROR,

  SEND_PROGRAM_APPROVE_REQUEST,
  SEND_PROGRAM_APPROVE_COMPLETED,
  SEND_PROGRAM_APPROVE_ERROR,

  GET_PROGRAM_AUTHORS_REQUEST,
  GET_PROGRAM_AUTHORS_COMPLETED,
  GET_PROGRAM_AUTHORS_ERROR,

  SEND_PROGRAM_AUTHORS_REQUEST,
  SEND_PROGRAM_AUTHORS_COMPLETED,
  SEND_PROGRAM_AUTHORS_ERROR
}
